module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_07-9116baa236f99d664a89678e65b60f46.png";